import {
  Grid,
  TextField,
  ThemeProvider,
  Typography,
  MenuItem,
} from "@mui/material";
import textFieldTheme from "./textfieldThemeProvider";

/**
 * Reusable Input / Select Component
 */
const InputSelectWithTopLable = ({
  label,
  value,
  onChange,
  type = "text",
  select = true,
  options = [],
  xs = 12,
  md = 12,
  getOptionLabel,
  getValue,
  textVariant,
  isRequired,
  ...props
}) => {
  return (
    <Grid item xs={xs} md={md}>
      {label && (
        <Typography variant={textVariant?textVariant:"body1"} mb={0.5}>
          {label} {isRequired && <span style={{color:"red"}}>*</span> }
        </Typography>
      )}

      <ThemeProvider theme={textFieldTheme}>
        <TextField
        
          type={type}
          value={value}
          onChange={onChange}
          select={select}
          {...props}
          SelectProps={{
  MenuProps: {
    PaperProps: {
      sx: {
        maxHeight: 250,
        overflowY: "auto",

        /* Scrollbar Style */
        "&::-webkit-scrollbar": {
          width: "6px",
        },

        "&::-webkit-scrollbar-track": {
          background: "#E8F5E9",
          borderRadius: "10px",
        },

        "&::-webkit-scrollbar-thumb": {
        
          borderRadius: "10px",
        },

       
      },
    },
  },
}}

        >
          {select &&
            options.map((item) => (
              <MenuItem
                key={item.id || item.value}
                value={getValue ? getValue(item) : item.value || item.id}
              
              >
                {getOptionLabel
                  ? getOptionLabel(item)
                  : item.label || item.name}
              </MenuItem>
            ))}
        </TextField>
      </ThemeProvider>
    </Grid>
  );
};

export default InputSelectWithTopLable;
